import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TableBody } from 'material-ui/Table';
import isEqual from 'lodash/isEqual';

/**
 * This wrapper is a monkey ass workaround for slow material-ui tables. Want more speed? Have fun updating material-ui
 */
class TableBodyOptimized extends Component {
  shouldComponentUpdate(nextProps) {
    const should = !isEqual(this.props.children.props.formData, nextProps.children.props.formData);
    // console.log('should update:', should);
    // if (should) {
    //   console.log('this.props.children.props.formData', this.props.children.props.formData);
    //   console.log('nextProps.children.props.formData', nextProps.children.props.formData);
    // }
    return should;
  }

  render() {
    const { children } = this.props;
    return <TableBody>{children}</TableBody>;
  }
}

TableBodyOptimized.propTypes = {
  children: PropTypes.object,
};

export default TableBodyOptimized;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/TableBodyOptimized.js